// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-AddressBook__addAddressButton__root","icon":"cmp-AddressBook__addAddressButton__icon","label":"cmp-AddressBook__addAddressButton__label"};